import { dbParameterGetCached } from '@devicebits/parameter-store'

const env = {
  stage: process.env.REACT_APP_STAGE,
  project: process.env.REACT_APP_PROJECT,
  flavor: process.env.REACT_APP_FLAVOR || 'default'
}

const paramApiConfig = {
  token: process.env.REACT_APP_DB_PARAM_API_TOKEN,
  url: process.env.REACT_APP_DB_PARAM_API_URL
}

export const getParam = dbParameterGetCached(paramApiConfig)(env)


// WEBPACK FOOTER //
// ./src/helpers/parameters.js